<template>
  <v-dialog v-model="value" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title class="title" style="justify-content: center; width: 100%">
        {{ isUpdate ? 'Editar dispositivo' : 'Alta de dispositivo' }}
      </v-card-title>
      <v-card-text>
        <v-text-field label="Nombre" outline flat v-model="deviceCopy.name" />
        <!-- <v-text-field
          disabled
          label="Token"
          outline
          flat
          v-model="deviceCopy.topic"
        /> -->
        <!-- <v-text-field
          disabled
          label="Topic"
          outline
          flat
          v-model="deviceCopy.accessToken"
        /> -->
        <v-select
          :disabled="loadingDoors"
          :loading="loadingDoors"
          v-model="deviceCopy.door"
          :items="doors"
          label="Puerta"
          item-text="name"
          item-value="id"
          flat
          small
          outline
          return-object
        />
      </v-card-text>
      <v-card-actions style="justify-content: end">
        <v-btn
          primary
          flat
          style="text-transform: capitalize !important"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-if="isUpdate"
          :disabled="isInvalidCreateBtn()"
          color="primary"
          class="body-2"
          style="text-transform: capitalize !important"
          @click="update"
        >
          Actualizar
        </v-btn>
        <v-btn
          v-if="!isUpdate"
          color="primary"
          class="body-2"
          style="text-transform: capitalize !important"
          @click="createDevice"
          :disabled="isInvalidCreateBtn()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    <Error v-model="modals.showError" :text="modals.errorText"> </Error>
    <Success v-model="modals.showSuccess" :text="modals.succesText"> </Success>
    <Loading v-model="modals.showLoading" text="Cargando..." />
  </v-dialog>
</template>

<script>
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'

export default {
  props: ['value', 'isUpdate', 'device'],
  components: {
    Error,
    Loading,
    Success,
  },
  data: () => ({
    loadingDoors: false,
    doors: [],
    deviceCopy: {
      name: '',
      door: { name: '' },
    },
    modals: {
      errorText: '',
      succesText: '',
      showError: false,
      showSuccess: false,
      showLoading: false,
    },
    doneProcess: true,
  }),
  watch: {
    value: async function () {
      if (this.value === true) {
        this.createCopyDevice()
        await this.getDoors()
      }
    },
  },
  methods: {
    async _delay(timeDelay = 1000) {
      await new Promise((resolve, _) => {
        const time = setTimeout(() => {
          resolve()
          clearTimeout(time)
        }, timeDelay)
      })
    },
    async createDevice() {
      this.doneProcess = false
      this.modals.showLoading = true
      try {
        await this.$store.dispatch('colleges/createRaspberry', [
          this.$route.params.id,
          {
            name: this.deviceCopy.name,
            idDoor: this.deviceCopy.door.id,
          },
        ])
        this.modals.succesText = 'Dispositivo creado exitosamente'
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.$emit('created')
        await this._delay()
        this.doneProcess = true
        this.close()
      } catch (error) {
        this.modals.showLoading = false
        console.log(error)
        const errors = {
          404: 'No se encontró el colegio proporcionado.',
          400: 'La puerta no pertenece al colegio proporcionado.',
        }

        this.modals.showError = true
        this.modals.errorText =
          errors[error.response.status] || 'Error al crear dispositivo'
      }
    },
    async update() {
      this.doneProcess = false
      this.modals.showLoading = true
      try {
        await this.$store.dispatch('colleges/updateRaspberry', [
          this.deviceCopy.id,
          {
            name: this.deviceCopy.name,
            idDoor: this.deviceCopy.door.id,
          },
        ])
        this.modals.succesText = 'Dispositivo actualizado exitosamente'
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.$emit('updated')
        await this._delay()
        this.doneProcess = true
        this.close()
      } catch (error) {
        this.modals.showLoading = false
        console.log(error)
        const errors = {
          404: 'No se encontró el colegio proporcionado.',
          400: 'La puerta no pertenece al colegio proporcionado.',
        }

        this.modals.showError = true
        this.modals.errorText =
          errors[error.response.status] || 'Error al actualizar dispositivo'
      }
    },
    async getDoors() {
      this.loadingDoors = true
      try {
        const { data } = await this.$store.dispatch(
          'colleges/getCollegeDoors',
          this.$route.params.id
        )

        this.doors = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingDoors = false
      }
    },
    close() {
      this.deviceCopy = {
        name: '',
        door: { name: '' },
      }
      this.$emit('input', !this.value)
    },
    cancel() {
      this.close()
    },
    createCopyDevice() {
      if (this.device === undefined) {
        this.deviceCopy = {
          name: '',
          door: { name: '' },
        }
        return
      }
      this.deviceCopy = structuredClone(this.device)
    },
    isInvalidCreateBtn() {
      const isEmptyDoor = this.deviceCopy.door.name.trim().length === 0
      const isEmptyName = this.deviceCopy.name.trim().length === 0

      if (
        isEmptyName ||
        isEmptyDoor ||
        this.modals.showLoading ||
        this.doneProcess === false
      )
        return true
      return false
    },
  },
}
</script>
